import request from '@/common/http/request'
// 获取游戏分类
export function getGameClassifyByTitle(data) {
    return request({
        url: '/gameTitle/listEnable',
        method: 'post',
        data
    })
}
// 获取游戏产商
export function getGameVendor(data) {
    return request({
        url: '/gameTitle/listEnableUnique',
        method: 'post',
        data
    })
}
// 获取游戏列表
export function getGameList(data) {
    return request({
        url: '/gameInfo/pageByTitle',
        method: 'post',
        data
    })
}
// 获取游戏All根据分类(新)
export function getAllGameListByClassify(data) {
    return request({
        url: '/gameInfo/queryGameListByAllTitle',
        method: 'post',
        data
    })
}
// 游戏列表收藏(新)
export function getGameCollect(data) {
    return request({
        url: '/memberGameFav/pageGameInfoFavorites',
        method: 'post',
        data
    })
}
// 轮播
export function homeInfo(data) {
    return request({
        url: '/home/getAll',
        method: 'post',
        data
    })
}
// 首页获取活动
let homeShowTimestamp = 0
export function getEventsHomeShow(data) {
    // Multiple homepage components can load in the same millisecond. Keep their requests distinct.
    const timestamp = Math.max(new Date().getTime(), homeShowTimestamp + 1)
    homeShowTimestamp = timestamp
    return request({
        url: '/eventManage/homeShow?timestamp=' + timestamp,
        method: 'post',
        data,
        isNoLoading: true
    })
}
// 友情链接
export function getFriendLogoList(data) {
    return request({
        url: '/home/friendLink',
        method: 'post',
        data
    })
}
